// services/onboardingProgressService.js
//
// Thin client for the POCAS onboarding progress/gate read-model (INC1) and the
// agreement e-sign endpoint (INC2). The backend is the single source of truth;
// the UI only reflects it. Auth follows the app convention: raw token in the
// Authorization header (no "Bearer" prefix).

import axios from 'axios';
import { API } from '../utils/apiUrls';

function authHeaders(token) {
  const authToken = token || localStorage.getItem('authToken');
  return authToken ? { Authorization: authToken } : {};
}

/**
 * Fetch the onboarding progress + entitlement model for a merchant.
 * @param {string} parentClientId
 * @param {string} [token]
 * @returns {Promise<Object>} progress model (see OnboardingProgressResponseApiModel)
 */
export async function fetchOnboardingProgress(parentClientId, token) {
  const response = await axios.get(API.onboardingProgress(parentClientId), {
    headers: authHeaders(token),
    timeout: 20000,
  });
  return response.data;
}

/**
 * Merchant e-signs the active agreement. Idempotent server-side.
 * @param {string} merchantId
 * @param {string} [token]
 */
export async function signOnboardingAgreement(merchantId, token) {
  const response = await axios.post(API.onboardingAgreementSign(merchantId), null, {
    headers: authHeaders(token),
    timeout: 20000,
  });
  return response.data;
}
